import { render, staticRenderFns } from "./AllSalesChannel.vue?vue&type=template&id=98649786&"
import script from "./AllSalesChannel.vue?vue&type=script&lang=js&"
export * from "./AllSalesChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports